import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { paramDeger } from '@/src/app/shared/utils/param-deger.utils';

const DURUM_RENK: Record<string, string> = { 'Bekliyor': '#94a3b8', 'Hazirlaniyor': '#ff9500', 'Tamamlandi': '#52c41a', 'Iptal': '#ff4d4f' };

@Component({
  selector: 'siparis-kart-sade',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="sk" style="--sk-accent:#f5730a">
      <div class="sk-icerik">
        <div class="sk-baslik">{{ deger('urunAdi') || 'Isimsiz Urun' }}</div>
        @if (deger('musteri')) { <div class="sk-alt">{{ deger('musteri') }}</div> }
        @if (deger('miktar') || deger('birimFiyat')) {
          <div class="sk-alt">{{ deger('miktar') || 0 }} x {{ deger('birimFiyat') || 0 }} {{ deger('paraBirimi') || 'TL' }}</div>
        }
      </div>
      <div class="sk-sag">
        <span style="font-size:14px;font-weight:700;color:var(--py-metin,#333)">{{ toplam() }}</span>
        @if (deger('durum')) { <span class="sk-chip" [style.border-color]="durumRenk()" [style.color]="durumRenk()">{{ deger('durum') }}</span> }
      </div>
    </div>
  `,
})
export class SiparisKartSadeComponent extends FikoYTKokBilesenComponent {
  parametreler = input<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});
  deger(alan: string): any { return paramDeger(this.p(), alan); }
  toplam = computed(() => {
    const miktar = +(this.deger('miktar') || 0);
    const fiyat = +(this.deger('birimFiyat') || 0);
    const t = miktar * fiyat;
    return t ? t.toLocaleString('tr-TR') + ' ' + (this.deger('paraBirimi') || 'TL') : '-';
  });
  durumRenk = computed(() => DURUM_RENK[this.deger('durum')] || '#94a3b8');
}
